export default {
    components: {
        colorPickerPopup: {
            moreOptions: {
                accordionTitle: {
                    stringName:
                        'txt_chayns_components_v5_color_picker_components_colorPickerPopup_moreOptions_accordionTitle',
                    fallback: 'Erweitert',
                },
            },
        },
    },
} as const;
